/* eslint-disable
    block-scoped-var,
    import-x/no-mutable-exports,
    no-cond-assign,
    no-loop-func,
    no-var,
    one-var,
    prefer-const,
    vars-on-top
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import reactUpdate from 'immutability-helper';
import $ from 'jquery';
import _ from 'underscore';

import {assert} from 'Asserts';
import * as biojs from 'BioJS';
import {DNA_COMPLEMENT_TABLE, DNA_IUPAC, DNA_IUPAC_ALL, DNA_IUPAC_TO_BASES} from 'biojs/BioConstants';
import {
  ALL_CODONS,
  AMINO_ACID_TO_STANDARD_DNA_CODONS,
  STANDARD_DNA_CODE,
  StandardDNACodon,
} from 'biojs/Codons';
import {Sequence as BioJSSequence} from 'biojs/Sequence';
import * as util from 'biojs/Util';
import {ImitationRegExp} from 'biojs/Util';
import {ComponentsSequence, Sequence} from 'components/Sequence';
import {
  DESIRED_HR_MISMATCHES,
  HR_TEMPLATE_STEP,
  MAX_GUIDE_LENGTH,
  MIN_GUIDE_LENGTH,
} from 'constants/CRISPRConstants';
import {EventConstants} from 'constants/EventConstants';
import FileStates, {SequenceFileState} from 'FileStates';
import AppDispatcher from 'lib/Dispatcher';
import {SequenceMatch} from 'molbio/biological-search/Search';
import {isLeftPam} from 'molbio/crispr/CRISPRUtil';
import HRTemplateStore, {
  HRTemplateColumn,
  HRTemplateDesignState,
  TargetSite,
} from 'molbio/crispr/hr-template/HRTemplateStore';
import * as SequenceDAO from 'molbio/dao/SequenceDAO';
import OrganismStore from 'molbio/genome/organism/OrganismStore';
import * as sequtil from 'molbio/SeqUtil';
import notifications, {Response} from 'notifications';
import * as LoadingScreen from 'ui-library/LoadingScreen';
import {withLoadingScreen} from 'util/Promises';

// @ts-expect-error
import * as HRTemplateDAO from './HRTemplateDAO';

// Replaces character in `string` at a specific `index` with a replacement `char`.
function _replaceChar(string: string, index: number, char: string): string {
  return `${string.slice(0, index)}${char}${string.slice(index + 1)}`;
}

function _replaceSubstring(string: string, index: number, newSub: string): string {
  return `${string.slice(0, index)}${newSub}${string.slice(index + newSub.length)}`;
}

// Search over a sequence to find the sites where the guide-pam combo will bind.
function _getTargetSites(
  _sequence: BioJSSequence,
  guide: string,
  pam: string,
  range?: {start: number; end: number} | null
): Array<SequenceMatch> {
  const pamPattern = util.generateRegex(pam); // maxMismatches for this defaults to 0, so PAM match is exact.
  const query = isLeftPam(pam) ? `${pam}${guide}` : `${guide}${pam}`;
  return _sequence.search(query, {
    maxMismatches: 4,
    filter(match: SequenceMatch) {
      // Make sure it ends with the PAM site with no mismatches.
      // Because match.sequence is in the sense direction, can use same pattern for matches on both strands.
      if (isLeftPam(pam)) {
        pamPattern.lastIndex = 0;
      } else {
        pamPattern.lastIndex = match.sequence!.length - pam.length;
      }
      if (pamPattern.exec(match.sequence!) != null) {
        return true;
      }
      return false;
    },
    range,
  });
}

// Find the end of translation for a specified region. Handles the case where the region is not a multiple
// of 3.
function _getTranslationEnd(start: number, end: number, length: number): number {
  if (end === 0) {
    end = length;
  }
  return end - ((end - start) % 3);
}

/**
 * Demote degenerate coding columns to non-coding columns because we can't suggest mutations.
 */
function demoteDegenerateCodingColumns(
  columns: Array<HRTemplateColumn>,
  sequenceBases: string,
  notify: boolean = true
): Array<HRTemplateColumn> {
  let anyDegenerateCodingColumns = false;
  const newColumns = columns.map((column) => {
    if (!column.isCoding) {
      return column;
    }
    const tripletBases = sequenceBases.slice(column.start, column.end);
    if (tripletBases.length !== 3 || !ALL_CODONS.includes(tripletBases.toUpperCase() as StandardDNACodon)) {
      anyDegenerateCodingColumns = true;
      return {
        ...column,
        isCoding: false,
      };
    }
    return column;
  });
  if (anyDegenerateCodingColumns && notify) {
    notifications.warn('Treating codons with degenerate bases as non-coding.');
  }
  return newColumns;
}

function _getColumns(
  sequence: BioJSSequence,
  targetSite: {start: number; end: number}
): Array<HRTemplateColumn> | null {
  // Get translations overlapping with the target site.
  let end;
  let translations = sequence
    .translations()
    .filter((t) =>
      sequtil.isRangeOverlap(
        targetSite.start,
        targetSite.end,
        t.start(),
        _getTranslationEnd(t.start(), t.end(), sequence.length())
      )
    )
    .map((t) => ({
      start: t.start(),
      end: _getTranslationEnd(t.start(), t.end(), sequence.length()),
    }));

  // Condense.
  translations = _.sortBy(translations, 'start');
  const exons: Array<{start: number; end: number}> = [];
  if (translations.length > 0) {
    // eslint-disable-next-line no-restricted-syntax
    let currentExon = _.first(translations)!;
    // eslint-disable-next-line no-restricted-syntax
    for (const translation of Array.from(_.rest(translations))) {
      if (translation.start > currentExon.end) {
        exons.push(currentExon);
        currentExon = translation;
      } else {
        if ((translation.start - currentExon.end) % 3 !== 0) {
          return null; // indicates conflicting translations.
        }
        currentExon.end = Math.max(currentExon.end, translation.end);
      }
    }
    exons.push(currentExon);
  }

  // Display all codons at least partially contained in the targetSite.
  const displayRange = (() => {
    if (!exons.length) {
      return {start: targetSite.start, end: targetSite.end};
    } else {
      // eslint-disable-next-line no-restricted-syntax
      const firstExon = _.first(exons);
      // eslint-disable-next-line no-restricted-syntax
      const lastExon = _.last(exons);
      return {
        start:
          firstExon!.start < targetSite.start
            ? targetSite.start - ((targetSite.start - firstExon!.start) % 3)
            : targetSite.start,
        end:
          lastExon!.end > targetSite.end
            ? targetSite.end + ((lastExon!.end - targetSite.end) % 3)
            : targetSite.end,
      };
    }
  })();

  // For ease of comprehension, build columns including introns.
  let index = displayRange.start;
  let columns: Array<HRTemplateColumn> = [];
  for (const exon of Array.from(exons)) {
    assert((exon.end - exon.start) % 3 === 0, 'Expected exon to have length that is a multiple of 3');
    end = Math.max(index, exon.start);
    columns.push({
      start: index,
      end,
      isCoding: false, // between two exons is an intron
    });
    index = end;
    // Split exons into codons.
    while (index < exon.end) {
      columns.push({
        start: index,
        end: Math.min(index + 3, displayRange.end),
        isCoding: true,
      });
      index += 3;
    }
    // @ts-expect-error: Missing arg
    assert((index = exon.end));
  }
  columns.push({
    start: index,
    end: displayRange.end,
    isCoding: false,
  });
  // eslint-disable-next-line no-restricted-syntax
  columns = _.filter(columns, ({start, end}) => start < end);
  columns.forEach((column) => {
    column.mutated = sequence.residueSlice(column.start, column.end) as StandardDNACodon;
  });
  return columns;
}

function _alternateBases(base: DNA_IUPAC_ALL): Array<DNA_IUPAC> {
  base = base.toUpperCase() as DNA_IUPAC;
  return (['A', 'C', 'G', 'T'] as Array<DNA_IUPAC>).filter(
    (b) => !Array.from(DNA_IUPAC_TO_BASES[base as DNA_IUPAC]).includes(b)
  );
}

export interface Mutation {
  index: number;
  base: DNA_IUPAC;
}

// Suggest mutations so that the guide does not bind to the HR Template DNA.
// If the DNA is translated, the algorithm attempts to find and introduce silent mutations.
// `codonUsage` maps codon to how frequently it is used in the DNA.
function _suggestMutations(
  bases: string,
  columns: Array<HRTemplateColumn>,
  guide: string,
  pam: string,
  codonUsage: Record<StandardDNACodon, number> | null,
  targetSite: TargetSite
): Array<Mutation> | null {
  let base,
    c,
    codon: StandardDNACodon,
    end,
    index,
    indices,
    j,
    m,
    mutant,
    mutants,
    mutations: Array<Mutation>,
    pamEnd,
    pamStart,
    start,
    targetSiteEnd: number,
    targetSiteStart: number;
  function _codonUsage(codon: StandardDNACodon): number {
    if (codonUsage != null) {
      return codonUsage[codon];
    } else {
      return 0;
    }
  }

  function _pamPattern(): RegExp | ImitationRegExp {
    if (['NGG', 'NAG'].includes(pam)) {
      // For SpCas9, we include NAG and NGG since both have measurable cutting efficiency
      return util.generateRegex('NRG');
    } else if (pam === 'NNGRRT') {
      // SaCas9 has measurable cutting efficiency at NNGRR, so we use that if the more specific PAM is set
      return util.generateRegex('NNGRR');
    }
    return util.generateRegex(pam);
  }

  const pamOnRight =
    (targetSite.strand === 1 && !isLeftPam(pam)) || (targetSite.strand === -1 && isLeftPam(pam));
  // First, try to mutate the PAM
  if (pamOnRight) {
    pamStart = targetSite.end - pam.length;
    pamEnd = targetSite.end;
    // Reverse the columns so mutations are picked closer to the PAM site first
    columns = columns.slice().reverse();
  } else {
    pamStart = targetSite.start;
    pamEnd = targetSite.start + pam.length;
  }

  for (var column of Array.from(columns)) {
    if (sequtil.isRangeOverlap(pamStart, pamEnd, column.start, column.end)) {
      var mutatedPamSequence;
      if (!column.isCoding) {
        start = Math.max(pamStart, column.start);
        end = Math.min(pamEnd, column.end);
        // Try mutations closer to PAM site first
        indices = __range__(start, end, false);
        if (pamOnRight) {
          indices.reverse();
        }
        for (index of Array.from(indices)) {
          for (const alternateBase of Array.from(_alternateBases(bases[index] as DNA_IUPAC_ALL))) {
            // Check if mutation actually affects the pam site.
            // @ts-expect-error: Unused variable
            const pamPattern = util.generateRegex(pam);
            mutatedPamSequence = _replaceChar(bases.slice(pamStart, pamEnd), index - pamStart, alternateBase);
            if (_pamPattern().exec(mutatedPamSequence) == null) {
              return [
                {
                  index,
                  base: alternateBase,
                },
              ];
            }
          }
          index++;
        }
      } else {
        codon = bases.slice(column.start, column.end) as StandardDNACodon;
        assert(ALL_CODONS.includes(codon.toUpperCase() as StandardDNACodon), 'Unexpected degenerate codon', {
          codon,
        });
        mutants =
          AMINO_ACID_TO_STANDARD_DNA_CODONS[STANDARD_DNA_CODE[codon.toUpperCase() as StandardDNACodon]];
        // Select the mutant that is the least different in codon usage and removes the PAM site
        const sortedMutants = _.sortBy(mutants, (mutant) =>
          Math.abs(_codonUsage(mutant) - _codonUsage(codon))
        );
        for (mutant of Array.from(sortedMutants)) {
          const mutatedBases = _replaceSubstring(bases, column.start, mutant);
          mutatedPamSequence = mutatedBases.slice(pamStart, pamEnd);
          if (targetSite.strand === -1) {
            mutatedPamSequence = util.revcomp(mutatedPamSequence, DNA_COMPLEMENT_TABLE);
          }

          if (_pamPattern().exec(mutatedPamSequence) == null) {
            mutations = [];
            const iterable = _.zip(codon, mutant);
            for (j = 0; j < iterable.length; j++) {
              [c, m] = iterable[j];
              if (c !== m) {
                mutations.push({
                  index: column.start + j,
                  base: m,
                });
              }
            }
            return mutations;
          }
        }
      }
    }
  }

  // Second, try to mutate the guide sequence
  // Because we have already checked the PAM site, restrict targetSite.
  if (targetSite.strand === 1) {
    targetSiteStart = targetSite.start;
    targetSiteEnd = pamStart;
  } else {
    targetSiteStart = pamEnd;
    targetSiteEnd = targetSite.end;
  }

  mutations = [];
  // Try to mutate the non-coding part, if present
  for (column of Array.from(columns)) {
    if (!column.isCoding) {
      start = Math.max(targetSiteStart, column.start);
      end = Math.min(targetSiteEnd, column.end);
      // Try mutations closer to PAM site first
      if (pamOnRight) {
        indices = __range__(end - 1, start - 1, false);
      } else {
        indices = __range__(start, end, false);
      }
      for (index of Array.from(indices)) {
        base = _alternateBases(bases[index] as DNA_IUPAC_ALL)[0];
        mutations.push({index, base});
        if (mutations.length >= DESIRED_HR_MISMATCHES) {
          return mutations;
        }
      }
    }
  }

  // Try to mutate the coding part by sorting all options by codon usage difference and greedily applying them
  const options = [];
  for (column of Array.from(columns)) {
    if (!column.isCoding) {
      continue;
    }
    codon = bases.slice(column.start, column.end) as StandardDNACodon;
    assert(ALL_CODONS.includes(codon.toUpperCase() as StandardDNACodon), 'Unexpected degenerate codon', {
      codon,
    });
    mutants = AMINO_ACID_TO_STANDARD_DNA_CODONS[STANDARD_DNA_CODE[codon.toUpperCase() as StandardDNACodon]];
    for (mutant of Array.from(mutants)) {
      if (mutant !== codon) {
        options.push({mutant, codon, column, diff: Math.abs(_codonUsage(mutant) - _codonUsage(codon))});
      }
    }
  }

  const usedColumns: {[index: number]: boolean} = {};
  for ({mutant, codon, column} of Array.from(_.sortBy(options, ({diff}) => diff))) {
    // eslint-disable-next-line benchlint/no-in-operator
    if (column.start in usedColumns) {
      continue;
    }

    const columnMutations = [];
    const iterable1 = _.zip(codon, mutant);
    for (j = 0; j < iterable1.length; j++) {
      [c, m] = iterable1[j];
      if (c !== m) {
        columnMutations.push({
          index: column.start + j,
          base: m,
        });
      }
    }

    // If the mutations are only in the PAM region, we already considered it and it has no effect on the PAM
    if (!_.any(columnMutations, ({index}) => sequtil.baseInRange(index, targetSiteStart, targetSiteEnd))) {
      continue;
    }

    usedColumns[column.start] = true;
    mutations = mutations.concat(columnMutations);
    if (mutations.length >= DESIRED_HR_MISMATCHES) {
      return mutations;
    }
  }

  // If there's at least one possible mutation then return it, otherwise return null so a warning is shown
  if (mutations.length) {
    return mutations;
  } else {
    return null;
  }
}

// Persist HR Template properties to the server. Can only be called with keys in the database.
function _serverUpdate(sequenceId: string, data: unknown): JQueryPromise<unknown> {
  // eslint-disable-next-line no-restricted-syntax
  for (const key of Array.from(_.keys(data))) {
    // @ts-expect-error: Missing arg
    assert(['genome', 'pam', 'step', 'guide', 'armRegion', 'savedVersions'].includes(key));
  }

  AppDispatcher.dispatch({actionType: EventConstants.HR_TEMPLATE_UPDATE, sequenceId});
  return HRTemplateDAO.update(sequenceId, data)
    .done((response: unknown) => {
      AppDispatcher.dispatch({
        actionType: EventConstants.HR_TEMPLATE_UPDATE_COMPLETED,
        sequenceId,
        data: response,
      });
    })
    .fail((response: Response) => {
      notifications.notifyError(response);
      AppDispatcher.dispatch({actionType: EventConstants.HR_TEMPLATE_UPDATE_FAILED, sequenceId});
    });
}

var HRTemplateActions = {
  create(sequence: Sequence, data: unknown): void {
    AppDispatcher.dispatch({
      actionType: EventConstants.HR_TEMPLATE_CREATE,
      sequenceId: sequence.id,
    });
    HRTemplateDAO.create(data)
      .done((response: unknown) => {
        // @ts-expect-error: Probably shouldn't add fields to response
        response.sequence = sequence;
        AppDispatcher.dispatch({
          actionType: EventConstants.HR_TEMPLATE_CREATE_COMPLETED,
          data: response,
          sequenceId: sequence.id,
        });
      })
      .fail((response: Response) => {
        notifications.notifyError(response);
        AppDispatcher.dispatch({
          actionType: EventConstants.HR_TEMPLATE_CREATE_FAILED,
          sequenceId: sequence.id,
        });
      });
  },

  update(sequenceId: string, data: unknown): void {
    AppDispatcher.dispatch({
      actionType: EventConstants.HR_TEMPLATE_UPDATE,
      sequenceId,
    });
    AppDispatcher.dispatch({
      actionType: EventConstants.HR_TEMPLATE_UPDATE_COMPLETED,
      sequenceId,
      data,
    });
  },

  serverUpdate(sequenceId: string, data: unknown): void {
    _serverUpdate(sequenceId, data);
  },

  fetchForSequence(sequenceId: string): void {
    AppDispatcher.dispatch({actionType: EventConstants.HR_TEMPLATE_FETCH_FOR_SEQUENCE, sequenceId});
    HRTemplateDAO.fetchForSequence({sequenceId})
      .done(({hrTemplateDesign}: {hrTemplateDesign: HRTemplateDesignState}) => {
        if (hrTemplateDesign == null) {
          AppDispatcher.dispatch({
            actionType: EventConstants.HR_TEMPLATE_FETCH_FOR_SEQUENCE_FAILED,
            sequenceId,
          });
          return;
        }

        const sequenceFile = FileStates.get().get(sequenceId) as SequenceFileState;
        hrTemplateDesign.sequence = sequenceFile.model();

        AppDispatcher.dispatch({
          actionType: EventConstants.HR_TEMPLATE_FETCH_FOR_SEQUENCE_COMPLETED,
          data: hrTemplateDesign,
          sequenceId,
        });
      })
      .fail((response: Response) => {
        notifications.notifyError(response);
        AppDispatcher.dispatch({
          actionType: EventConstants.HR_TEMPLATE_FETCH_FOR_SEQUENCE_FAILED,
          sequenceId,
        });
      });
  },

  updatePendingSelection(sequenceId: string, pendingSelection: unknown): void {
    AppDispatcher.dispatch({
      actionType: EventConstants.HR_TEMPLATE_UPDATE_PENDING_SELECTION,
      sequenceId,
      pendingSelection,
    });
  },

  suggestMutations(sequenceId: string): void {
    let i, mutated;
    const {sequence, columns, guide, pam, organismId, targetSite, _mutatedSequence} =
      HRTemplateStore.getDesignState(sequenceId)!;

    const sequenceBases = sequence!.bases();
    const normalizedColumns = demoteDegenerateCodingColumns(columns!, sequenceBases);

    let mutations = _suggestMutations(
      sequenceBases,
      normalizedColumns,
      guide,
      pam,
      OrganismStore.getCodonUsage(organismId),
      targetSite!
    );

    if (mutations == null) {
      HRTemplateActions.update(sequenceId, {columns: normalizedColumns});
      notifications.warn('Could not find suitable mutations.');
      return;
    }

    // mutations is not necessarily sorted because mutations015 and mutations030 were concatenated.
    mutations = _.sortBy(mutations, 'index');
    const columnMutations: Array<{i: number; mutated: StandardDNACodon}> = [];
    let columnMutation = null;
    i = 0; // current column index
    let k = 0; // current mutation index
    let {index, base} = mutations[k];
    while (i < normalizedColumns.length) {
      const column = normalizedColumns[i];
      // Reset to original sequence bases (what _suggestMutations bases its suggestions off of).
      columnMutation = {i, mutated: sequence!.residueSlice(column.start, column.end) as StandardDNACodon};
      while (sequtil.baseInRange(index, column.start, column.end)) {
        columnMutation.mutated = _replaceChar(
          columnMutation.mutated,
          index - column.start,
          base
        ) as StandardDNACodon;
        k++;
        if (k < mutations.length) {
          ({index, base} = mutations[k]);
        } else {
          index = -1; // to continue looping through all the columns
        }
      }
      columnMutations.push(columnMutation);
      i++;
    }

    HRTemplateActions.update(sequenceId, {
      columns: reactUpdate(
        normalizedColumns,
        _.object(
          (() => {
            const result = [];
            for ({i, mutated} of Array.from(columnMutations)) {
              result.push([i, {mutated: {$set: mutated}}]);
            }
            return result;
          })()
        )
      ),
    });

    // Check for new target sites.
    for ({i, mutated} of Array.from(columnMutations)) {
      _mutatedSequence.replaceBases(normalizedColumns[i].start, normalizedColumns[i].end, mutated);
    }

    // Restrict search to the vicinity of the current targetSite.
    const targetSites = _getTargetSites(_mutatedSequence, guide, pam, {
      start: Math.max(0, targetSite!.start - guide.length - pam.length),
      end: Math.min(_mutatedSequence.length(), targetSite!.end + guide.length + pam.length),
    });

    if (targetSites.length === 0) {
      HRTemplateActions.update(sequenceId, {
        warningMessage: null,
        targetSite: reactUpdate(targetSite, {stale: {$set: true}}),
      });
      return;
    }

    // eslint-disable-next-line no-restricted-syntax
    const newTargetSites = _.filter(targetSites, (ts) => ts.index !== targetSite!.start);
    assert(!newTargetSites.length, 'Expected no new target sites'); // should have checked before setting mutations
  },

  // May leave a stale warningMessage if an errorMessage is being set (MutantTable will not show it).
  setGuide(sequenceId: string, guide?: string | null): void {
    let promise;
    if (guide == null) {
      guide = __guard__<HRTemplateDesignState, string>(
        HRTemplateStore.getDesignState(sequenceId),
        (x) => x.guide
      )!;
    }
    guide = util.sanitize(guide, util.NucleotideType.DNA);
    HRTemplateActions.update(sequenceId, {guide});

    if (!guide) {
      HRTemplateActions.update(sequenceId, {errorMessage: null, columns: null});
      return;
    }

    if (!(MIN_GUIDE_LENGTH <= guide.length && guide.length <= MAX_GUIDE_LENGTH)) {
      HRTemplateActions.update(sequenceId, {
        errorMessage: `Guide must be ${MIN_GUIDE_LENGTH}-${MAX_GUIDE_LENGTH} bp in length`,
      });
      return;
    }

    const {sequence, pam, step, savedVersions} = HRTemplateStore.getDesignState(sequenceId)!;

    // On the summary step we need to get an older version of the sequence.
    if (step === HR_TEMPLATE_STEP.SUMMARY) {
      const summaryVersion = savedVersions[HR_TEMPLATE_STEP.SUMMARY];
      // Make request to get actual full sequence version.
      promise = SequenceDAO.getVersion(sequenceId, summaryVersion.id).then((version) =>
        $.Deferred()
          .resolve(new biojs.Sequence(version, {parse: true}))
          .promise()
      );
    } else {
      promise = $.Deferred().resolve(sequence!._sequence()).promise();
    }

    promise.done((sequence: BioJSSequence) => {
      let index;
      const targetSites = _getTargetSites(sequence, guide, pam);

      if (targetSites.length !== 1) {
        HRTemplateActions.update(sequenceId, {
          errorMessage: (() => {
            if (targetSites.length === 0) {
              return `No target sites found for guide ${guide} and PAM ${pam}`;
            } else {
              const indices = (() => {
                const result = [];
                for ({index} of Array.from(targetSites)) {
                  result.push(sequtil.modelStartToDisplay(index, sequence.startIndex()));
                }
                return result;
              })();
              return `Multiple target sites for guide ${guide} and PAM ${pam} \
found at positions: ${indices.join(', ')}`;
            }
          })(),
        });
        return;
      }

      const [targetSite] = Array.from(targetSites);
      assert(
        targetSite.sequence!.length === guide.length + pam.length,
        'Expected target site length to be equal to guide length plus PAM length'
      );
      // @ts-expect-error: Should probably not add to targetSite variable
      targetSite.start = targetSite.index;
      // @ts-expect-error: Should probably not add to targetSite variable
      targetSite.end = targetSite.start + targetSite.sequence!.length;
      // @ts-expect-error: Should probably not add to targetSite variable
      targetSite.stale = false;

      // @ts-expect-error: Should probably not add to targetSite variable
      const columns = _getColumns(sequence, targetSite);
      if (columns == null) {
        HRTemplateActions.update(sequenceId, {
          errorMessage: 'Found overlapping translations on different reading frames in the target site.',
        });
        return;
      }

      HRTemplateActions.update(sequenceId, {
        errorMessage: null,
        warningMessage: null,
        targetSite,
        columns,
        _mutatedSequence: new biojs.Sequence({bases: sequence.bases()}),
      });
      if (step === HR_TEMPLATE_STEP.REMOVE_TARGET_SITE) {
        // Suggest mutations only if we are going to choose between them.
        HRTemplateActions.suggestMutations(sequenceId);
      }
    });
  },

  // This is only called once a guide has been set successfully, so don't have to worry about errorMessage.
  setMutatedBases(sequenceId: string, i: number, bases: string): void {
    // @ts-expect-error: Unused variable
    let {sequence, pam, guide, targetSite, columns, _mutatedSequence} =
      HRTemplateStore.getDesignState(sequenceId)!;

    bases = util.sanitize(bases, util.NucleotideType.DNA);
    columns = reactUpdate(columns, _.object([[i, {mutated: {$set: bases}}]]));
    HRTemplateActions.update(sequenceId, {
      columns,
    });

    // eslint-disable-next-line no-restricted-syntax
    if (_.some(columns!, (column) => column.end - column.start !== column.mutated!.length)) {
      HRTemplateActions.update(sequenceId, {
        warningMessage: 'Length mismatch',
      });
      return;
    }

    _mutatedSequence.replaceBases(columns![i].start, columns![i].end, bases);

    // Restrict search to the vicinity of the current targetSite.
    const targetSites = _getTargetSites(_mutatedSequence, guide, pam, {
      start: Math.max(0, targetSite!.start - guide.length - pam.length),
      end: Math.min(_mutatedSequence.length(), targetSite!.end + guide.length + pam.length),
    });

    if (targetSites.length === 0) {
      HRTemplateActions.update(sequenceId, {
        warningMessage: null,
        // Set stale so the table can still be displayed even though the targetSite is actually gone.
        targetSite: reactUpdate(targetSite, {stale: {$set: true}}),
      });
      return;
    }

    // eslint-disable-next-line no-restricted-syntax
    const newTargetSites = _.filter(targetSites, (ts) => ts.index !== targetSite!.start);
    if (newTargetSites.length) {
      HRTemplateActions.update(sequenceId, {
        /* eslint-disable no-restricted-syntax */
        warningMessage: `Your mutations have introduced new target sites at \
${_.map(newTargetSites, (ts) => ts.index).join(', ')}
        .`,
        /* eslint-enable no-restricted-syntax */
      });
    } else {
      HRTemplateActions.update(sequenceId, {
        warningMessage: null,
        targetSite: reactUpdate(targetSite, {stale: {$set: false}}),
      });
    }
  },

  _replaceHelper(
    sequence: ComponentsSequence,
    _mutatedSequence: BioJSSequence,
    intervals: Array<{start: number; end: number}>,
    intervalIndex: number
  ): void {
    let mutatedBases;
    const callback =
      intervalIndex === 0
        ? function () {
            HRTemplateActions.update(sequence.id, {
              modifyingSequence: false,
            });
            LoadingScreen.hide();
          }
        : HRTemplateActions._replaceHelper.bind(
            null,
            sequence,
            _mutatedSequence,
            intervals,
            intervalIndex - 1
          );

    const {start, end} = intervals[intervalIndex];
    if (sequence.residueSlice(start, end) !== (mutatedBases = _mutatedSequence.residueSlice(start, end))) {
      sequence.replace(start, end, mutatedBases, {callback}).fail(() => {
        LoadingScreen.hide();
      });
    } else {
      callback();
    }
  },

  saveMutations(sequenceId: string): void {
    const {sequence, columns, _mutatedSequence} = HRTemplateStore.getDesignState(sequenceId)!;
    LoadingScreen.show();
    HRTemplateActions.update(sequence!.id, {
      modifyingSequence: true,
    });

    if (columns == null) {
      // Step was skipped, so no mutations to make
      HRTemplateActions.update(sequence!.id, {
        modifyingSequence: false,
      });
      LoadingScreen.hide();
      return;
    }

    // Preserve translations by only modifying within them.
    let currentInterval = {start: columns[0].start, end: columns[0].end};
    let {isCoding} = columns[0];
    const intervals = [currentInterval];
    // eslint-disable-next-line no-restricted-syntax
    for (const column of Array.from(_.rest(columns))) {
      if (column.isCoding === isCoding) {
        currentInterval.end = column.end;
      } else {
        currentInterval = {start: column.start, end: column.end};
        ({isCoding} = column);
        intervals.push(currentInterval);
      }
    }

    HRTemplateActions._replaceHelper(sequence!, _mutatedSequence, intervals, intervals.length - 1);
  },

  // Revert sequence to older version, update to specified step.
  backToStep(sequenceId: string, step: unknown): void {
    HRTemplateActions.update(sequenceId, {resettingToVersion: true});
    const {sequence} = HRTemplateStore.getDesignState(sequenceId)!;
    _serverUpdate(sequenceId, {step})
      .done((hrTemplateDesign: {armRegion: {start: number; end: number}}) => {
        sequence!.fetch().done(() => {
          if (step === HR_TEMPLATE_STEP.SELECT_ARMS && hrTemplateDesign.armRegion) {
            const {start, end} = hrTemplateDesign.armRegion;
            if (start != null && end != null) {
              sequence!.selection().setEndpoints(start, end);
            }
          }
          sequence!.updateVersions({showHistoryPanel: false, switchToLast: true});
        });
      })
      .always(() => {
        HRTemplateActions.update(sequenceId, {resettingToVersion: false});
      });
  },

  designWithNewGuide(sequenceId: string, originalBases: string): void {
    let {sequence, savedVersions} = HRTemplateStore.getDesignState(sequenceId)!;
    const version = savedVersions[HR_TEMPLATE_STEP.SUMMARY];
    // Clone the sequence which will also clone the HR Template.
    withLoadingScreen(
      SequenceDAO.cloneVersion(
        sequenceId,
        version.id,
        sequence!.folder()!.api_identifier,
        `${sequence!.name()} (HR template copy)`
      )
        .then((res) => FileStates.get().openFolderItem(res.id, {open: true, source: 'hr-template-design'}))
        .then((res) => {
          const sequenceFile = FileStates.get().get(res!.id) as SequenceFileState;
          sequence = sequenceFile.model();
          const updatedData = {
            step: HR_TEMPLATE_STEP.REMOVE_TARGET_SITE,
            guide: '',
          };
          const data = HRTemplateStore.defaultDesign({sequence});
          HRTemplateActions.update(res!.id, data);
          HRTemplateActions.serverUpdate(res!.id, updatedData);

          const HRTemplateTabState = require('./HRTemplateTabState').default;
          sequenceFile.buffers().addTab(new HRTemplateTabState({sequence}));
        })
    );
  },
  demoteDegenerateCodingColumns,
  _alternateBases,
  __getTargetSites: _getTargetSites,
  _getColumns,
  _suggestMutations,
};
export default HRTemplateActions;

function __range__(left: number, right: number, inclusive: boolean): Array<number> {
  const range = [];
  const ascending = left < right;
  const end = !inclusive ? right : ascending ? right + 1 : right - 1;
  for (let i = left; ascending ? i < end : i > end; ascending ? i++ : i--) {
    range.push(i);
  }
  return range;
}
function __guard__<T, R>(value: T | null, transform: (input: T) => R): R | undefined {
  return value != null ? transform(value) : undefined;
}
